import { Button } from '@avanta/shared/components/ui/Button';
import { Card } from '@avanta/shared/components/ui/Card';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { cn } from '@avanta/shared/utils/cn';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useUserStore } from 'stores/user';

export const PsychologistPresentation = (): React.ReactElement | null => {
  const { t, i18n } = useTranslation(LOCIZE_NS.PROFILE);
  const user = useUserStore(state => state.user);
  const isPsychologist = useUserStore(state => state.isPsychologist);
  const [isExpanded, setIsExpanded] = useState(false);

  const presentation =
    user?.presentations?.[i18n.language as keyof typeof user.presentations] ??
    user?.presentations?.es;

  if (!isPsychologist || !presentation) return null;

  return (
    <Card className="bg-white" title={t('PsychologistPresentation.heading')}>
      <div className="flex flex-col gap-4">
        <p
          className={cn(
            'text-sm text-gray-600 leading-relaxed',
            !isExpanded && 'line-clamp-4',
            isExpanded && 'whitespace-pre-wrap'
          )}
        >
          {presentation}
        </p>
        <div className="flex justify-center pt-1">
          <Button
            variant="terciary"
            className="no-underline"
            onClick={() => setIsExpanded(prev => !prev)}
          >
            {isExpanded
              ? t('PsychologistPresentation.states.showLess')
              : t('PsychologistPresentation.states.showMore')}
          </Button>
        </div>
      </div>
    </Card>
  );
};
